import type { ReactElement } from 'react'
import { Link } from 'react-router'
import { useI18n } from '../i18n/useI18n'
import { legalPageList } from '../data/legal/legalPages'
import { addressLines, company } from '../data/company'
import OrgNumber from './OrgNumber'
import './Footer.css'

export default function Footer(): ReactElement {
  const { lang, t } = useI18n()
  const year = new Date().getFullYear()

  return (
    <footer className="sm-footer">
      <div className="container">
        <div className="row gy-4">
          <div className="col-md-4">
            <div className="d-flex align-items-center mb-3">
              <img src="/logo.svg" alt="StructuraMatrix" className="footer-logo" />
              <span className="footer-brand">StructuraMatrix</span>
            </div>
            <p className="footer-tagline">{t('footer.tagline')}</p>
          </div>
          <div className="col-md-4 ms-md-auto text-md-end footer-company">
            <div className="footer-company-name">{company.legalName}</div>
            <div><OrgNumber /></div>
            <div>{addressLines(company.businessAddress).join(', ')}</div>
            <a href={`mailto:${company.email}`}>{company.email}</a>
          </div>
        </div>
        <hr className="footer-divider" />
        <div className="footer-bottom">
          <span>{t('footer.copyright', { year })}</span>
          <nav className="footer-legal" aria-label={t('footer.legalNav')}>
            {legalPageList.map((p) => <Link key={p.id} to={p.path}>{p.document.content[lang].title}</Link>)}
          </nav>
        </div>
      </div>
    </footer>
  )
}
